import { AccessManagementSection } from './components/access-management-section'
import type { SettingsInvite, SettingsNotification, SettingsUser } from './types'

export type { SettingsInvite, SettingsNotification, SettingsUser } from './types'

export interface SettingsViewProps {
  subtitle?: string
  hideHeading?: boolean
  users: SettingsUser[]
  invites?: SettingsInvite[]
  notifications?: SettingsNotification[]
  activityLogPath?: string
  onInvite?: (email: string, role: 'OWNER' | 'WRITE' | 'READ') => void
  onCancelInvite?: (inviteId: string) => void
  onRemoveMember?: (memberId: string) => void
  isInviting?: boolean
  isOwner?: boolean
  /** Width of the page column; the default is the wide one. */
  widthClassName?: string
}

export function SettingsView({
  subtitle = 'Manage your workspace settings',
  hideHeading = false,
  users,
  invites,
  onInvite,
  onCancelInvite,
  onRemoveMember,
  isInviting,
  isOwner,
  widthClassName = 'max-w-6xl',
}: SettingsViewProps) {
  return (
    <div className={`mx-auto ${widthClassName} py-2`}>
      {!hideHeading && (
        <>
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">Settings</h1>
          <p className="mt-1 mb-6 text-sm text-muted-foreground">{subtitle}</p>
        </>
      )}

      <AccessManagementSection
        users={users}
        invites={invites ?? []}
        onInvite={onInvite ?? (() => {})}
        onCancelInvite={onCancelInvite ?? (() => {})}
        onRemoveMember={onRemoveMember}
        isInviting={isInviting}
        isOwner={isOwner}
      />
      {/* TODO: Notifications, Security, Privacy — hidden until implemented */}
    </div>
  )
}
